// One-time seed data for the master catalog. Seeding is idempotent —
// existing names (case-insensitive) are skipped, so this is safe to re-run.

export const SEED_CATEGORIES = [
  { name: 'Hair', sortOrder: 10 },
  { name: 'Beard', sortOrder: 20 },
  { name: 'Facial', sortOrder: 30 },
  { name: 'Hair Color', sortOrder: 40 },
  { name: 'Hair Spa', sortOrder: 50 },
  { name: 'Makeup', sortOrder: 60 },
  { name: 'Bridal', sortOrder: 70 },
  { name: 'Nails', sortOrder: 80 },
  { name: 'Waxing', sortOrder: 90 },
  { name: 'Hair Removal', sortOrder: 95 },
  { name: 'Threading', sortOrder: 100 },
  { name: 'Skin Care', sortOrder: 110 },
  { name: 'Body Care', sortOrder: 115 },
  { name: 'Massage', sortOrder: 120 },
  { name: 'Body Grooming', sortOrder: 125 },
  { name: 'Kids', sortOrder: 130 },
  { name: 'Tattoo', sortOrder: 140 },
  { name: 'Others', sortOrder: 150 }
];

// categoryName must match a SEED_CATEGORIES name.
// subServices carry only names + default durations; prices are always per-salon.
export const SEED_SERVICES = [
  // Hair
  { name: 'Haircut', categoryName: 'Hair', gender: 'Men', defaultDuration: 30 },
  {
    name: "Women's Haircut", categoryName: 'Hair', gender: 'Women', defaultDuration: 45,
    subServices: [
      { name: 'Short', defaultDuration: 30 },
      { name: 'Medium', defaultDuration: 45 },
      { name: 'Long', defaultDuration: 60 },
      { name: 'Bob Cut', defaultDuration: 30 },
      { name: 'Lob Cut', defaultDuration: 30 },
      { name: 'Pixie Cut', defaultDuration: 30 },
      { name: 'Blunt Cut', defaultDuration: 30 },
      { name: 'Wolf Cut', defaultDuration: 45 },
      { name: 'Curtain Bangs', defaultDuration: 30 }
    ]
  },
  { name: 'Hair Wash', categoryName: 'Hair', gender: 'Unisex', defaultDuration: 15 },
  { name: 'Blow Dry', categoryName: 'Hair', gender: 'Women', defaultDuration: 30 },
  {
    name: 'Hair Straightening', categoryName: 'Hair', gender: 'Women', defaultDuration: 120,
    subServices: [
      { name: 'Shoulder Length', defaultDuration: 90 },
      { name: 'Mid Length', defaultDuration: 120 },
      { name: 'Full Length', defaultDuration: 120 }
    ]
  },
  { name: 'Hair Ironing', categoryName: 'Hair', gender: 'Women', defaultDuration: 45 },
  { name: 'Head Shave', categoryName: 'Hair', gender: 'Men', defaultDuration: 15 },
  { name: 'Hair Styling', categoryName: 'Hair', gender: 'Unisex', defaultDuration: 30 },

  // Beard
  { name: 'Beard Trim', categoryName: 'Beard', gender: 'Men', defaultDuration: 15 },
  { name: 'Shave', categoryName: 'Beard', gender: 'Men', defaultDuration: 15 },
  { name: 'Beard Styling', categoryName: 'Beard', gender: 'Men', defaultDuration: 30 },

  // Facial
  {
    name: 'Facial', categoryName: 'Facial', gender: 'Unisex', defaultDuration: 45,
    subServices: [
      { name: 'Basic', defaultDuration: 45 },
      { name: 'Gold', defaultDuration: 60 },
      { name: 'Diamond', defaultDuration: 60 }
    ]
  },
  { name: 'Clean Up', categoryName: 'Facial', gender: 'Unisex', defaultDuration: 30 },
  { name: 'De-Tan', categoryName: 'Facial', gender: 'Unisex', defaultDuration: 30 },

  // Hair Color
  {
    name: 'Hair Coloring', categoryName: 'Hair Color', gender: 'Unisex', defaultDuration: 60,
    subServices: [
      { name: 'Root Touch-up', defaultDuration: 45 },
      { name: 'Global', defaultDuration: 90 },
      { name: 'Highlights', defaultDuration: 120 },
      { name: 'Balayage', defaultDuration: 120 },
      { name: 'Lowlights', defaultDuration: 90 },
      { name: 'Ombre', defaultDuration: 120 },
      { name: 'Fashion Shades', defaultDuration: 90 },
      { name: 'Ammonia-Free', defaultDuration: 60 }
    ]
  },
  { name: 'Beard Color', categoryName: 'Hair Color', gender: 'Men', defaultDuration: 15 },

  // Hair Spa
  {
    name: 'Hair Spa', categoryName: 'Hair Spa', gender: 'Unisex', defaultDuration: 45,
    subServices: [
      { name: 'Basic', defaultDuration: 45 },
      { name: 'Premium', defaultDuration: 60 }
    ]
  },
  { name: 'Anti-Dandruff Treatment', categoryName: 'Hair Spa', gender: 'Unisex', defaultDuration: 45 },
  { name: 'Keratin Treatment', categoryName: 'Hair Spa', gender: 'Women', defaultDuration: 120 },
  { name: 'Hair Smoothening', categoryName: 'Hair Spa', gender: 'Women', defaultDuration: 120 },

  // Makeup
  {
    name: 'Party Makeup', categoryName: 'Makeup', gender: 'Women', defaultDuration: 60,
    subServices: [
      { name: 'Natural Makeup', defaultDuration: 60 },
      { name: 'Glam Makeup', defaultDuration: 90 },
      { name: 'Reception Makeup', defaultDuration: 90 },
      { name: 'Engagement Makeup', defaultDuration: 90 }
    ]
  },
  { name: 'HD Makeup', categoryName: 'Makeup', gender: 'Women', defaultDuration: 90 },
  { name: 'Saree Draping', categoryName: 'Makeup', gender: 'Women', defaultDuration: 30 },

  // Bridal
  {
    name: 'Bridal Makeup', categoryName: 'Bridal', gender: 'Women', defaultDuration: 120,
    subServices: [
      { name: 'Basic', defaultDuration: 120 },
      { name: 'Premium', defaultDuration: 120 }
    ]
  },
  { name: 'Engagement Makeup', categoryName: 'Bridal', gender: 'Women', defaultDuration: 90 },
  { name: 'Groom Makeup', categoryName: 'Bridal', gender: 'Men', defaultDuration: 60 },
  { name: 'Mehendi', categoryName: 'Bridal', gender: 'Women', defaultDuration: 60 },

  // Nails
  {
    name: 'Manicure', categoryName: 'Nails', gender: 'Unisex', defaultDuration: 45,
    subServices: [
      { name: 'Basic', defaultDuration: 45 },
      { name: 'Spa', defaultDuration: 60 }
    ]
  },
  {
    name: 'Pedicure', categoryName: 'Nails', gender: 'Unisex', defaultDuration: 45,
    subServices: [
      { name: 'Basic', defaultDuration: 45 },
      { name: 'Spa', defaultDuration: 60 }
    ]
  },
  {
    name: 'Nail Art', categoryName: 'Nails', gender: 'Women', defaultDuration: 60,
    subServices: [
      { name: 'French Tips', defaultDuration: 45 },
      { name: 'Chrome Finish', defaultDuration: 60 },
      { name: 'Glitter', defaultDuration: 45 },
      { name: '3D Art', defaultDuration: 90 },
      { name: 'Hand Painted Art', defaultDuration: 90 }
    ]
  },
  {
    name: 'Nail Extension', categoryName: 'Nails', gender: 'Women', defaultDuration: 90,
    subServices: [
      { name: 'Acrylic Extensions', defaultDuration: 120 },
      { name: 'Gel Extensions', defaultDuration: 120 }
    ]
  },

  // Waxing
  { name: 'Full Body Wax', categoryName: 'Waxing', gender: 'Women', defaultDuration: 90 },
  { name: 'Full Arms Wax', categoryName: 'Waxing', gender: 'Women', defaultDuration: 30 },
  { name: 'Full Legs Wax', categoryName: 'Waxing', gender: 'Women', defaultDuration: 30 },
  { name: 'Underarms Wax', categoryName: 'Waxing', gender: 'Women', defaultDuration: 15 },

  // Threading
  { name: 'Eyebrow Threading', categoryName: 'Threading', gender: 'Women', defaultDuration: 15 },
  { name: 'Upper Lip Threading', categoryName: 'Threading', gender: 'Women', defaultDuration: 15 },
  { name: 'Full Face Threading', categoryName: 'Threading', gender: 'Women', defaultDuration: 30 },

  // Skin Care
  {
    name: 'Bleach', categoryName: 'Skin Care', gender: 'Unisex', defaultDuration: 30,
    subServices: [
      { name: 'Face', defaultDuration: 30 },
      { name: 'Body', defaultDuration: 60 }
    ]
  },
  {
    name: 'Body Polishing', categoryName: 'Skin Care', gender: 'Women', defaultDuration: 90,
    subServices: [
      { name: 'Ubtan Polish', defaultDuration: 60 },
      { name: 'Brightening Polish', defaultDuration: 60 },
      { name: 'Glow Polish', defaultDuration: 60 }
    ]
  },

  // Massage
  {
    name: 'Head Massage', categoryName: 'Massage', gender: 'Unisex', defaultDuration: 30,
    subServices: [
      { name: 'Oil', defaultDuration: 30 },
      { name: 'Dry', defaultDuration: 30 }
    ]
  },
  {
    name: 'Body Massage', categoryName: 'Massage', gender: 'Unisex', defaultDuration: 60,
    subServices: [
      { name: 'Relaxation', defaultDuration: 60 },
      { name: 'Deep Tissue', defaultDuration: 90 },
      { name: 'Swedish', defaultDuration: 60 }
    ]
  },

  // Kids
  { name: 'Kids Haircut', categoryName: 'Kids', gender: 'Unisex', defaultDuration: 30 },
  { name: 'Kids Haircut (Boys)', categoryName: 'Kids', gender: 'Men', defaultDuration: 30 },
  { name: 'Kids Haircut (Girls)', categoryName: 'Kids', gender: 'Women', defaultDuration: 30 },

  // --- Expanded catalog (salon service list, second pass) ---

  // Hair — Men
  { name: 'Senior Citizen Haircut', categoryName: 'Hair', gender: 'Men', defaultDuration: 30 },
  {
    name: 'Hair Straightening (Men)', categoryName: 'Hair', gender: 'Men', defaultDuration: 90
  },

  // Hair — Women
  { name: 'Fringe / Bangs Cut', categoryName: 'Hair', gender: 'Women', defaultDuration: 15 },
  { name: 'Hair Wash & Blow Dry', categoryName: 'Hair', gender: 'Women', defaultDuration: 30 },
  { name: 'Tong Curls / Styling', categoryName: 'Hair', gender: 'Women', defaultDuration: 45 },

  // Beard & Shave
  { name: 'Clean Shave', categoryName: 'Beard', gender: 'Men', defaultDuration: 15 },
  { name: 'Royal / Luxury Shave', categoryName: 'Beard', gender: 'Men', defaultDuration: 30 },
  { name: 'Moustache Styling', categoryName: 'Beard', gender: 'Men', defaultDuration: 15 },

  // Hair Color — Men
  {
    name: "Men's Hair Colour", categoryName: 'Hair Color', gender: 'Men', defaultDuration: 30,
    subServices: [
      { name: 'Basic', defaultDuration: 30 },
      { name: 'Ammonia-Free', defaultDuration: 30 }
    ]
  },
  { name: 'Moustache Colour', categoryName: 'Hair Color', gender: 'Men', defaultDuration: 15 },
  { name: 'Highlights (Men)', categoryName: 'Hair Color', gender: 'Men', defaultDuration: 90 },
  { name: 'Global Hair Colour (Men)', categoryName: 'Hair Color', gender: 'Men', defaultDuration: 60 },

  // Facial
  {
    name: "Men's Facial", categoryName: 'Facial', gender: 'Men', defaultDuration: 45,
    subServices: [
      { name: 'Basic', defaultDuration: 45 },
      { name: 'Advanced', defaultDuration: 60 },
      { name: 'Premium', defaultDuration: 60 }
    ]
  },
  { name: 'Fruit Facial', categoryName: 'Facial', gender: 'Women', defaultDuration: 45 },
  { name: 'Anti-Ageing Facial', categoryName: 'Facial', gender: 'Women', defaultDuration: 60 },
  { name: 'Skin Brightening Facial', categoryName: 'Facial', gender: 'Women', defaultDuration: 60 },

  // Hair Spa / Treatments
  { name: 'Hair Smoothening (Men)', categoryName: 'Hair Spa', gender: 'Men', defaultDuration: 120 },
  { name: 'Hair Fall Treatment', categoryName: 'Hair Spa', gender: 'Unisex', defaultDuration: 45 },
  { name: 'Scalp Treatment', categoryName: 'Hair Spa', gender: 'Unisex', defaultDuration: 45 },
  { name: 'Rebonding', categoryName: 'Hair Spa', gender: 'Women', defaultDuration: 120 },
  { name: 'Botox Hair Treatment', categoryName: 'Hair Spa', gender: 'Women', defaultDuration: 120 },
  { name: 'Nanoplastia', categoryName: 'Hair Spa', gender: 'Women', defaultDuration: 120 },
  { name: 'Perming', categoryName: 'Hair Spa', gender: 'Women', defaultDuration: 120 },

  // Massage
  { name: 'Shoulder & Neck Massage', categoryName: 'Massage', gender: 'Unisex', defaultDuration: 30 },
  { name: 'Face Massage', categoryName: 'Massage', gender: 'Unisex', defaultDuration: 30 },

  // Skin Care
  { name: 'Face Scrub / Polishing', categoryName: 'Skin Care', gender: 'Unisex', defaultDuration: 30 },

  // Threading
  { name: 'Forehead / Chin Threading', categoryName: 'Threading', gender: 'Women', defaultDuration: 15 },
  { name: 'Eyebrow Shaping', categoryName: 'Threading', gender: 'Women', defaultDuration: 15 },
  { name: 'Threading', categoryName: 'Threading', gender: 'Unisex', defaultDuration: 15 },

  // Waxing
  { name: 'Bikini Waxing', categoryName: 'Waxing', gender: 'Women', defaultDuration: 30 },
  { name: 'Face Waxing', categoryName: 'Waxing', gender: 'Women', defaultDuration: 15 },
  { name: 'Chocolate / Rica Wax', categoryName: 'Waxing', gender: 'Women', defaultDuration: 60 },

  // Nails
  { name: 'Crack Heel Treatment', categoryName: 'Nails', gender: 'Women', defaultDuration: 30 },
  { name: 'Nail Cutting & Filing', categoryName: 'Nails', gender: 'Unisex', defaultDuration: 15 },
  { name: 'Nail Polish Application', categoryName: 'Nails', gender: 'Women', defaultDuration: 15 },

  // Bridal & Occasion
  { name: 'Hair Styling (Occasion)', categoryName: 'Bridal', gender: 'Women', defaultDuration: 60 },
  {
    name: 'Pre-Bridal Package', categoryName: 'Bridal', gender: 'Women', defaultDuration: 120,
    subServices: [
      { name: 'Skin Care Package', defaultDuration: 120 },
      { name: 'Hair Care Package', defaultDuration: 120 },
      { name: 'Body Care Package', defaultDuration: 120 },
      { name: 'Bridal Grooming', defaultDuration: 120 }
    ]
  },

  // --- All-India catalog (third pass) ---

  // Hair
  {
    name: 'Updo & Hairstyling', categoryName: 'Hair', gender: 'Women', defaultDuration: 60,
    subServices: [
      { name: 'Messy Bun', defaultDuration: 45 },
      { name: 'French Twist', defaultDuration: 45 },
      { name: 'Bridal Bun', defaultDuration: 90 },
      { name: 'Half Updo', defaultDuration: 45 },
      { name: 'Traditional Braid', defaultDuration: 45 },
      { name: 'Party Hairstyle', defaultDuration: 60 }
    ]
  },
  {
    name: 'Hair Tattoo / Razor Design', categoryName: 'Hair', gender: 'Men', defaultDuration: 30,
    subServices: [
      { name: 'Razor Line Design', defaultDuration: 15 },
      { name: 'Hair Tattoo', defaultDuration: 30 },
      { name: 'Fade Detailing', defaultDuration: 15 }
    ]
  },

  // Hair Spa / Treatments
  {
    name: 'Japanese Head Spa', categoryName: 'Hair Spa', gender: 'Unisex', defaultDuration: 60,
    subServices: [
      { name: 'Scalp Analysis', defaultDuration: 30 },
      { name: 'Scalp Detox', defaultDuration: 60 },
      { name: 'Steam Therapy', defaultDuration: 45 },
      { name: 'Lymphatic Head Massage', defaultDuration: 60 }
    ]
  },
  {
    name: 'Bond Repair Treatment', categoryName: 'Hair Spa', gender: 'Unisex', defaultDuration: 45,
    subServices: [
      { name: 'Olaplex Bond Repair', defaultDuration: 60 },
      { name: 'K18 Molecular Repair', defaultDuration: 45 }
    ]
  },
  {
    name: 'Hair Loss Treatment', categoryName: 'Hair Spa', gender: 'Unisex', defaultDuration: 60,
    subServices: [
      { name: 'Hair Growth Therapy', defaultDuration: 60 },
      { name: 'Stem Cell Therapy', defaultDuration: 60 },
      { name: 'Peptide Therapy', defaultDuration: 60 },
      { name: 'Microneedling', defaultDuration: 60 }
    ]
  },

  // Facial
  {
    name: 'Medi Facial', categoryName: 'Facial', gender: 'Unisex', defaultDuration: 60,
    subServices: [
      { name: 'Dermalogica Facial', defaultDuration: 60 },
      { name: 'Vitamin C Facial', defaultDuration: 60 },
      { name: 'Retinol Facial', defaultDuration: 60 },
      { name: 'Hyaluronic Facial', defaultDuration: 60 }
    ]
  },
  {
    name: 'Carbon Laser Facial', categoryName: 'Facial', gender: 'Unisex', defaultDuration: 45,
    subServices: [
      { name: 'Carbon Peel', defaultDuration: 45 },
      { name: 'Q-Switch Laser Facial', defaultDuration: 60 }
    ]
  },

  // Hair Removal
  {
    name: 'Laser Hair Reduction', categoryName: 'Hair Removal', gender: 'Unisex', defaultDuration: 60,
    subServices: [
      { name: 'Face', defaultDuration: 30 },
      { name: 'Underarms', defaultDuration: 30 },
      { name: 'Arms', defaultDuration: 60 },
      { name: 'Legs', defaultDuration: 60 },
      { name: 'Bikini', defaultDuration: 45 },
      { name: 'Full Body', defaultDuration: 120 }
    ]
  },

  // Body Care
  {
    name: 'Body Scrub', categoryName: 'Body Care', gender: 'Unisex', defaultDuration: 45,
    subServices: [
      { name: 'Coffee Scrub', defaultDuration: 45 },
      { name: 'Oatmeal Scrub', defaultDuration: 45 },
      { name: 'Apricot Scrub', defaultDuration: 45 }
    ]
  },
  {
    name: 'Body Wrap', categoryName: 'Body Care', gender: 'Unisex', defaultDuration: 60,
    subServices: [
      { name: 'Chocolate Wrap', defaultDuration: 60 },
      { name: 'Seaweed Wrap', defaultDuration: 90 },
      { name: 'Clay Wrap', defaultDuration: 60 }
    ]
  },

  // Nails
  {
    name: 'Gel Polish', categoryName: 'Nails', gender: 'Women', defaultDuration: 45,
    subServices: [
      { name: 'Gel Polish Application', defaultDuration: 45 },
      { name: 'Gel Polish Removal', defaultDuration: 30 }
    ]
  },
  {
    name: 'BIAB', categoryName: 'Nails', gender: 'Women', defaultDuration: 60,
    subServices: [
      { name: 'Builder Gel Overlay', defaultDuration: 60 }
    ]
  },

  // Makeup
  {
    name: 'Temporary Eyelash Extensions', categoryName: 'Makeup', gender: 'Women', defaultDuration: 30,
    subServices: [
      { name: 'Strip Lashes', defaultDuration: 15 },
      { name: 'Individual Lashes', defaultDuration: 30 }
    ]
  },

  // Beard
  {
    name: 'Beard Spa', categoryName: 'Beard', gender: 'Men', defaultDuration: 30,
    subServices: [
      { name: 'Beard Cleansing', defaultDuration: 15 },
      { name: 'Beard Conditioning', defaultDuration: 30 },
      { name: 'Beard Oil Massage', defaultDuration: 30 }
    ]
  },

  // Body Grooming
  {
    name: 'Chest Grooming', categoryName: 'Body Grooming', gender: 'Men', defaultDuration: 30,
    subServices: [
      { name: 'Chest Waxing', defaultDuration: 30 },
      { name: 'Chest Trimming', defaultDuration: 15 }
    ]
  },
  {
    name: 'Back Grooming', categoryName: 'Body Grooming', gender: 'Men', defaultDuration: 30,
    subServices: [
      { name: 'Back Waxing', defaultDuration: 30 },
      { name: 'Back Trimming', defaultDuration: 15 }
    ]
  }
];
